import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { NavLink } from "react-router-dom";
import useApi from '../../hooks/useApi';
import EventToAgentBind from '../event/EventToAgentBind';
//
// Компонент выводит два списка:
// 1) Список привязанных к агенту мероприятий
// 2) Список мероприятий, которые еще можно привязать
//
const AgentToEventList = ({ agent }) => {
	const { t, i18n } = useTranslation();
    const lang = i18n.language;
    const auth = useSelector(state => state.auth.user);
    // eslint-disable-next-line
    const [ params, setParams ] = useState({ agent: agent._id, admin: auth._id });
    // eslint-disable-next-line
    const [ method, setMethod ] = useState(auth.role === 'root' ? '/events' : '/eventsbyadmin');
	const [ binds, errorBinds, isLoadingBinds ] = useApi({ type: 'get', method: '/agent2event', params });
	const [ events, errorEvents, isLoadingEvents ] = useApi({ type: 'get', method, params });
    const [ bindsTo, setBindsTo ] = useState(null);

    // Убираем из второго списка тех, кто уже есть в первом
    useEffect(() => {
        if(!binds || !events) return;
        for(let i = 0; i < binds.agent2event.length; i ++) {
            let event_id = binds.agent2event[i].event._id;
            let index = events.events.findIndex(event => event._id === event_id);
            if(index >= 0) {
                events.events.splice(index, 1);
            }
        }
        setBindsTo(events.events);
    }, [binds, events]);
/*
    TODO: Эта функция будет нужна, когда поймем как вызывать из <UserToEventBind>
    обновление родителя (чтобы сразу отобразить новые списки). Пока не ясно как
    сделать вызов после того, как изменение привязки произошло на сервере. Часто
    вызов обновления проходит раньше, чем изменения произошли.
    const update = () => {
        // Для форсирования повторного запроса АПИ
        // мы делаем вид что поменяли параметры запроса.
        setParams({ admin: user._id });
    };
*/
	return (
    <div>
        <h2>{t('agent2event.binds')}</h2>
        {errorBinds && <div className='error'>{t(errorBinds)}</div>}
        {isLoadingBinds && <div>{t('loader.title')}</div>}
        {binds &&
        <React.Fragment>
            {binds.agent2event.length ?
            <ul>
            {binds.agent2event.map(item => (
                <li key={item._id}>
                    { (auth.role === 'root' || auth.role === 'admin')
                    ? <NavLink to={'/cabinet/eventview/'+item.event._id}>{item.event.name[lang]}</NavLink>
                    : <NavLink to={'/cabinet/exhibitorlistbyevent/'+item.event._id}>{item.event.name[lang]}</NavLink> }
                    &nbsp;
                    <EventToAgentBind agent={agent._id} event={item.event._id} limit={item.limit} bind={false}/>
                </li>
            ))}
            </ul> : <div>{t('agent2event.nobinds')}</div>}
        </React.Fragment>}

        {(auth.role === 'root' || auth.role === 'admin') &&
        <React.Fragment>
            <h2>{t('agent2event.bindto')}</h2>
            {errorEvents && <div className='error'>{t(errorEvents)}</div>}
            {isLoadingEvents && <div>{t('loader.title')}</div>}
            {bindsTo &&
            <React.Fragment>
                {bindsTo.length ?
                <ul>
                {bindsTo.map(item => (
                    <li key={item._id}>
                        <NavLink to={'/cabinet/eventview/'+item._id}>{item.name[lang]}</NavLink>&nbsp;
                        <EventToAgentBind agent={agent._id} event={item._id} bind={true}/>
                    </li>
                ))}
                </ul> : <div>{t('agent2event.nobindto')}</div>}
            </React.Fragment>}
        </React.Fragment>}
    </div>
	);
};

AgentToEventList.propTypes = {
    agent: PropTypes.object.isRequired,
};

export default AgentToEventList;
